import React from 'react';
import SEO from '../components/SEO';

const content = {
  es: {
    seoTitle: "Aviso Legal | Barberà Fit",
    imprintTitle: "Aviso Legal",
    imprintSections: [
      { title: "Responsable del contenido", body: "Mathias Deppe" },
      { title: "Dirección", body: "Nemesi Valls 42\n08210 Barberà del Vallès\nBarcelona, España" },
      { title: "Contacto y Soporte", body: "Correo electrónico: contact@barberadelvalles.fit\nTeléfono: +34 623780182" },
      { title: "Identificación Fiscal", body: "NIF/NIE: Y8187448Z" },
      { title: "Resolución de Litigios de la UE", body: "La Comisión Europea ofrece una plataforma para la resolución de litigios en línea (RLL): https://ec.europa.eu/consumers/odr. No estamos dispuestos ni obligados a participar en procedimientos de resolución de conflictos ante una junta de arbitraje de consumo." }
    ]
  },
  en: {
    seoTitle: "Imprint (Legal Notice) | Barberà Fit",
    imprintTitle: "Imprint (Legal Notice)",
    imprintSections: [
      { title: "Responsible for Content", body: "Mathias Deppe" },
      { title: "Address", body: "Nemesi Valls 42\n08210 Barberà del Vallès\nBarcelona, Spain" },
      { title: "Contact & Support", body: "Email: contact@barberadelvalles.fit\nPhone: +34 623780182" },
      { title: "Tax Identification", body: "VAT/Tax ID (NIF/NIE): Y8187448Z" },
      { title: "EU Dispute Resolution", body: "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr. We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board." }
    ]
  }
};

export default function Imprint({ lang }) {
  const t = content[lang];

  const renderBody = (text) => {
    // Handle Email
    const email = "contact@barberadelvalles.fit";
    // Handle URLs
    const url = "https://ec.europa.eu/consumers/odr";

    let elements = [text];

    // Process URLs first
    if (text.includes(url)) {
      const parts = text.split(url);
      elements = [
        parts[0],
        <a key="odr-link" href={url} target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline break-all">
          {url}
        </a>,
        parts[1]
      ];
    }

    // Process Email
    return elements.map((item, i) => {
      if (typeof item === 'string' && item.includes(email)) {
        const emailParts = item.split(email);
        return (
          <React.Fragment key={`email-frag-${i}`}>
            {emailParts[0]}
            <a href={`mailto:${email}`} className="text-orange-500 hover:underline font-bold">
              {email}
            </a>
            {emailParts[1]}
          </React.Fragment>
        );
      }
      return item;
    });
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-20 bg-slate-900/50 rounded-3xl my-12 backdrop-blur-sm border border-slate-800/50">
      <SEO title={t.seoTitle} description={`${t.imprintTitle} - Barberà del Vallès Fit`} lang={lang} />
      
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-12 border-b-4 border-orange-600 pb-4 inline-block">
        {t.imprintTitle}
      </h1>
      
      <div className="space-y-12">
        {t.imprintSections.map((section, idx) => (
          <div key={idx} className="space-y-4">
            <h2 className="text-xl font-bold text-orange-500 uppercase tracking-widest text-sm">
              {section.title}
            </h2>
            <div className="text-slate-300 leading-relaxed text-lg whitespace-pre-line">
              {renderBody(section.body)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}